import Header from 'components/headers/home'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import MobilePic from 'assets/images/home/Mobile_and_Notebook.svg'
import CalenderPic from 'assets/images/home/calender-icon.svg'
import Roadmap from 'assets/images/home/banner.svg'
import Headphone from 'assets/images/home/Headphone.svg'
import AccountNumber from 'assets/images/home/AccountNumber.svg'
import MoarefCode from 'assets/images/home/MoarefCode.svg'
import MiniCalender from 'assets/images/home/MiniCalender.svg'
import Wallet from 'assets/images/home/Wallet.svg'
import Faq from 'assets/images/home/Faq.svg'
import HowToStart from 'assets/images/home/HowToStart.svg'
import SuccessStory from 'assets/images/home/SuccessStory.svg'
import RulesAndConditions from 'assets/images/home/RulesAndConditions.svg'
import HamyanInMedia from 'assets/images/home/HamyanInMedia.svg'
import Arrow from 'assets/images/home/Arrow.svg'
import { getThisWeek } from 'utilities/helper/getThisWeek'
import classNames from 'classnames'
import { toast } from 'react-toastify'
import SupportModal from 'components/modals/supportModal'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
export default function HomePage() {
    const [openSupport, setOpenSupport] = useState<boolean>(false)
    const navigate = useNavigate()
    const week = getThisWeek()
    return (
        <div className="bg-white min-h-screen pb-4">
            <Header title="همیان" />
            <SideBar>
                <SideBarItems />
            </SideBar>

            {/* Hero banner (item_home_hor_banner): green rounded card with the
                accounting illustration floating above and the title bottom-right */}
            <div className="px-2 pt-4">
                <div className="relative bg-green-1 rounded-[10px] h-[140px]">
                    <img
                        src={MobilePic}
                        alt="mobile-home"
                        className="absolute left-8 right-8 -top-[100px] h-[200px] object-contain"
                    />
                    <p className="absolute bottom-2 right-4 text-right text-white font-bold text-[18px]">
                        حسابداری از این آسون تر؟
                    </p>
                </div>
            </div>

            {/* Weekday strip (cnsLimitedCalendar) */}
            <div className="mt-4 mx-[10px] flex items-stretch">
                {week.map((item, index) => (
                    <div
                        key={index}
                        className="flex-1 h-[100px] flex flex-col items-center"
                    >
                        {/* Top half: day number anchored to its bottom, with an
                            invisible red event dot (imgCircleDay/ic_red_circle_taghvim) */}
                        <div className="flex-1 flex flex-col justify-end items-center">
                            <div className="relative flex flex-col items-center">
                                <span
                                    className={classNames(
                                        'font-bold text-sm',
                                        index === 0
                                            ? 'text-green-1'
                                            : 'text-black'
                                    )}
                                >
                                    {item.day}
                                </span>
                                <span className="invisible w-[28px] h-[22px]" />
                            </div>
                        </div>
                        {/* Bottom half: weekday name anchored to its top */}
                        <span
                            className={classNames(
                                'flex-1 text-sm max-w-full truncate',
                                index === 0 ? 'text-green-1' : 'text-black'
                            )}
                        >
                            {item.name}
                        </span>
                    </div>
                ))}
                <div className="flex-1 h-[100px] flex items-center justify-center">
                    <img src={CalenderPic} alt="calendar" className="w-10 h-10" />
                </div>
            </div>

            {/* Coaching banner (cnsCoaching) */}
            <div className="mt-4 mx-4 bg-[#E6F3DD] rounded-[10px] p-4 flex items-center gap-3">
                <img
                    src={Roadmap}
                    alt="Roadmap to build a 30m box"
                    className="h-[65px] object-contain shrink-0"
                />
                <div className="flex-1 text-right">
                    <p className="font-bold text-base text-heading truncate">
                        با کمک همیان، صندوق وام خودتو بساز!
                    </p>
                    <p className="text-sm text-[#888888] truncate">
                        ۱۲ قدم تا صندوق پس‌انداز ۳۰ میلیونی
                    </p>
                    <div className="flex justify-end mt-2">
                        <button
                            type="button"
                            className="bg-white rounded-[16px] text-xs text-black px-4 pb-[2px] cursor-pointer"
                            onClick={() =>
                                toast.error('این صفحه در حال توسعه است')
                            }
                        >
                            شروع
                        </button>
                    </div>
                </div>
            </div>

            {/* Quick-action grid (constraintLayout) */}
            <div className="mt-4 bg-white p-4">
                <div className="grid grid-cols-3 gap-y-4">
                    {/* Row 1 (RTL): ضمانت‌های من - مدیریت کارت‌ها - پشتیبانی
                        (was a تقویم placeholder that only raised a
                        "در حال توسعه" toast) */}
                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() => navigate('/guarantees')}
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3 text-xl">
                            🤝
                        </div>
                        <p className="mt-1 text-sm text-text-body">
                            ضمانت‌های من
                        </p>
                    </div>

                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() => navigate('/manage-bank-cards')}
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3">
                            <img
                                src={AccountNumber}
                                alt=""
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <p className="mt-1 text-sm text-text-body">
                            مدیریت کارت‌‌ها
                        </p>
                    </div>

                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() => setOpenSupport(true)}
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3">
                            <img
                                src={Headphone}
                                alt=""
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <p className="mt-1 text-sm text-text-body">پشتیبانی</p>
                    </div>

                    {/* Row 2 (RTL): سوالات متداول - کیف پول - کد معرف */}
                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() =>
                            window.location.replace(
                                'https://hamyanapp.com/blog/faq/'
                            )
                        }
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3">
                            <img
                                src={Faq}
                                alt=""
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <p className="mt-1 text-sm text-text-body">
                            سوالات متداول
                        </p>
                    </div>

                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() => navigate('/wallet')}
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3">
                            <img
                                src={Wallet}
                                alt=""
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <p className="mt-1 text-sm text-text-body">کیف پول</p>
                    </div>

                    <div
                        className="cursor-pointer flex flex-col items-center"
                        onClick={() =>
                            toast.error('این صفحه در حال توسعه است')
                        }
                    >
                        <div className="w-12 h-12 bg-[#E6F3DD] rounded-[10px] flex items-center justify-center p-3">
                            <img
                                src={MoarefCode}
                                alt=""
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <p className="mt-1 text-sm text-text-body">کد معرف</p>
                    </div>
                </div>
            </div>

            {/* "بیشتر بدانید:" section title (textView3) */}
            <p className="mt-4 mr-4 text-right text-sm text-text-body">
                بیشتر بدانید:
            </p>

            {/* Info rows (cnsSuccessOfBoxes / cnsStartPoint / cnsTerms / cnsHamyanInSocial) */}
            <div className="mt-[10px]">
                <div
                    className="cursor-pointer bg-white px-4 py-2 flex items-center gap-2"
                    onClick={() => toast.error('این صفحه در حال توسعه است')}
                >
                    <img
                        src={Arrow}
                        alt="Success story arrow"
                        className="w-4 h-4"
                    />
                    <p className="flex-1 text-right text-base text-text-body">
                        داستان موفقیت صندوق‌ها
                    </p>
                    <img
                        src={SuccessStory}
                        alt="Success story"
                        className="w-10 h-10"
                    />
                </div>
                <div
                    className="cursor-pointer bg-white px-4 py-2 mt-1 flex items-center gap-2"
                    onClick={() =>
                        window.location.replace(
                            'https://hamyanapp.com/how-to-use/'
                        )
                    }
                >
                    <img
                        src={Arrow}
                        alt="How to start arrow"
                        className="w-4 h-4"
                    />
                    <p className="flex-1 text-right text-base text-text-body">
                        از کجا شروع کنم؟
                    </p>
                    <img
                        src={HowToStart}
                        alt="How to start"
                        className="w-10 h-10"
                    />
                </div>
                <div
                    className="cursor-pointer bg-white px-4 py-2 mt-1 flex items-center gap-2"
                    onClick={() =>
                        window.location.replace('https://hamyanapp.com/policy/')
                    }
                >
                    <img
                        src={Arrow}
                        alt="Rules and conditions arrow"
                        className="w-4 h-4"
                    />
                    <p className="flex-1 text-right text-base text-text-body">
                        قوانین و مقررات
                    </p>
                    <img
                        src={RulesAndConditions}
                        alt="Rules and conditions"
                        className="w-10 h-10"
                    />
                </div>
                <div
                    className="cursor-pointer bg-white px-4 py-2 mt-1 flex items-center gap-2"
                    onClick={() => toast.error('این صفحه در حال توسعه است')}
                >
                    <img
                        src={Arrow}
                        alt="Hamyan in media arrow"
                        className="w-4 h-4"
                    />
                    <p className="flex-1 text-right text-base text-text-body">
                        همیان در رسانه‌ها
                    </p>
                    <img
                        src={HamyanInMedia}
                        alt="Hamayan in media"
                        className="w-10 h-10"
                    />
                </div>
            </div>

            <SupportModal
                show={openSupport}
                onHide={() => setOpenSupport(false)}
            />
        </div>
    )
}
